module.exports = __webpack_public_path__ + "img/Pickpocket.ddd908d0.png";